















































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { globalStore, Error, BreadCrumb } from "@/store/modules/GlobalStore";
import AI from "./services/ApplicationInsights";
import { accountStore } from "./store/modules/AccountStore";
import { Routes } from "./router/Routes";
import { NullableString } from "./code/Types";

@Component
export default class App extends Vue {
  drawer = null;
  showError = false;

  async created(): Promise<void> {
    await AI.initialize();
  }

  get userFullName(): NullableString | undefined {
    return accountStore.user?.agentFullName;
  }

  get userInitials(): string {
    let initials = "";
    if (accountStore.user?.agentFirstName) {
      initials += accountStore.user.agentFirstName.toUpperCase().charAt(0);
    }
    if (accountStore.user?.agentLastName) {
      initials += accountStore.user.agentLastName.toUpperCase().charAt(0);
    }
    return initials;
  }

  get isBusy(): boolean {
    return globalStore.isBusy;
  }

  get version(): string {
    return globalStore.version;
  }

  get error(): Error | null {
    return globalStore.error;
  }

  get title(): string {
    return globalStore.title;
  }

  get breadCrumbs(): BreadCrumb[] {
    return globalStore.breadCrumbs;
  }
  get userLoggedIn(): boolean {
    return accountStore.isLoggedIn;
  }

  get showNavigationBar(): boolean {
    return globalStore.isWelcomePage === false && this.userLoggedIn === true;
  }

  async logoff(): Promise<void> {
    await accountStore.logOff();
    await this.$router.push({ name: Routes.LOGIN });
  }

  @Watch("error")
  onError(newVal: Error): void {
    if (newVal) {
      this.showError = true;
    }
  }

  get supportEmail(): string {
    return "support@thepalladiumgrp.com";
  }

  @Watch("globalStore.isWelcomePage")
  get isWelcomePage(): boolean {
    return globalStore.isWelcomePage;
  }

  items = [
    {
      title: "Clients",
      icon: "mdi-account-box-multiple",
      subTitle:"",
      href: "/",
    },
    {
      title: "Existing Policies",
      subTitle:"(With Carrier Feeds)",
      icon: "mdi-chart-box-outline",
      href: "/existingbusiness",
    },
    {
      title: "Existing Policies",
      subTitle:"(No Carrier Feeds)",
      icon: "mdi-chart-box-outline",
      href: "/existingPolicies",
    },
  ];
  }
